(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-login"]) return;
  try {
    
window.document.onload = (event) => {
  if (window.location.href.includes('#recover')) {
    const event = new CustomEvent('dialog:trigger:recover');
    document.dispatchEvent(event);
  }
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  customElements.whenDefined('slideshow-component').then(() => {
    document.querySelectorAll('slideshow-component:has(.lenic-hero-dots)').forEach((slideshow) => {
      if (slideshow.dataset.lenicDotsReady) return;
      slideshow.dataset.lenicDotsReady = 'true';
      const slides = [...slideshow.querySelectorAll('.slideshow__slide')];
      const buttons = [...slideshow.querySelectorAll('[data-lenic-slide]')];
      const update = () => {
        const active = slides.findIndex((slide) => slide.getAttribute('aria-hidden') === 'false');
        buttons.forEach((button, index) => button.setAttribute('aria-current', String(index === active)));
      };
      buttons.forEach((button, index) => button.addEventListener('click', () => {
        slideshow.jumpToSlide(slides[index], false);
        update();
      }));
      const observer = new MutationObserver(update);
      slides.forEach((slide) => observer.observe(slide, { attributes: true, attributeFilter: ['aria-hidden'] }));
      update();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
